import React from "react";
import { ConfirmDialog, IconButton, useDisclosure, useNotifications } from "sprint-common-web";

import { useNotesState } from "../hooks/state/useNotesState";
import { useNotesActions } from "../hooks/useNotesActions";

export interface NoteDeleteProps {
    id: string;
}

export const NoteDelete: React.FC<NoteDeleteProps> = ({ id }: NoteDeleteProps) => {
    const { success, error } = useNotifications();
    const { deleteNote } = useNotesActions();
    const { setNotes, notes, subjectId, subjectType, disabled } = useNotesState();
    const { isOpen, onOpen, onClose } = useDisclosure();

    const handleDeleteNote = async () => {
        try {
            await deleteNote(subjectId, id, subjectType);

            setNotes(notes.filter((note) => note.id !== id));
            success("Note deleted successfully");
        } catch (e) {
            console.error(e);
            onClose();
            error("Failed to delete");
        } finally {
            onClose();
        }
    };

    if (disabled) {
        return null;
    }

    return (
        <>
            <IconButton
                iconProps={{ iconName: "Delete" }}
                testId="delete-note-button"
                onClick={onOpen}
                tooltipContent="Delete the note"
            />
            <ConfirmDialog
                title="Delete note"
                text="Are you sure you want to delete this note?"
                confirm={{ onClick: handleDeleteNote }}
                cancel={{ onClick: onClose }}
                hidden={!isOpen}
            />
        </>
    );
};
